/**
 * * Configuração para os componentes de abas.
 */
export class TabConfig {

  constructor(
    /**
     * * Título (texto) da aba.
     */
    public title: string,
    /**
     * * Aba selecionada.
     */
    public selected: boolean,
    /**
     * * Evento a ser executado ao selecionar a aba.
     */
    public tabEvent?: Function,
    /**
     * * Contexto (escopo) da função.
     */
    public functionContext?: any,
    /**
     * * Aba desabilitada.
     */
    public disabled?: boolean,
    /**
     * * Identificador da aba.
     */
    public id?: string,
    ) {}

}
